<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.physicalExams', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card-title">
                    <router-link :to="{ name: 'add-consultation-physical-exam' }">
                        {{ $t('message.add') }}

                        <i class="fas fa-plus-circle edit-icon"></i>
                    </router-link>
                </div>

                <template v-if="rows">
                    <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            class="mb-3"
                            aria-controls="physicals-table"
                    ></b-pagination>

                    <b-container>
                        <b-row class="justify-content-sm-center">
                            <b-col col sm="6">
                                <b-form-group>
                                    <autocomplete
                                            ref="autocomplete"
                                            :placeholder="$t('message.search')"
                                            :source="mPhysicals"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            @selected="itemSelected"
                                    ></autocomplete>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-container>

                    <b-table
                            id="physicals-table"
                            primary-key="id"
                            :per-page="perPage"
                            :current-page="currentPage"
                            selectable
                            select-mode="single"
                            borderless
                            responsive
                            striped
                            hover
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            @row-selected="rowSelected"
                            :fields="fields"
                            :items="mPhysicals"
                    >
                        <!-- A virtual composite column for actions -->
                        <template slot="action" slot-scope="data">
                            <div class="row">
                                <div class="col-sm-12">
                                    <i v-b-modal="'delete-modal-' + data.item.slug" class="fas fa-trash fa-2x delete-icon"></i>
                                </div>
                            </div>

                            <b-modal
                                    :id="'delete-modal-' + data.item.slug"
                                    size="sm"
                                    header-bg-variant="danger"
                                    header-text-variant="light"
                                    :title="$t('message.delete') + ' ' + $tc('message.physicalExams', 1)"
                                    hide-footer
                            >
                                <div class="d-block text-center">
                                    <h3>{{ $t('message.delete') }} {{ data.item.reference }}?</h3>
                                </div>

                                <div class="d-block float-right">
                                    <b-button class="secondary" @click="deletePhysicalExam(data.item.slug)">
                                        {{ $t('message.delete') }}
                                    </b-button>

                                    <b-button class="danger" @click="$bvModal.hide('delete-modal-' + data.item.slug)">
                                        {{ $t('message.cancel') }}
                                    </b-button>
                                </div>
                            </b-modal>
                        </template>
                    </b-table>

                    <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="physicals-table"
                    ></b-pagination>
                </template>

                <template v-else>
                    <div class="card">
                        <div class="card-body text-xs-center">
                            <p class="card-text">
                                {{ $t('message.noResults') }}
                            </p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';

    export default {
        name: "PhysicalExams",

        computed: {
            ...mapGetters(["physicalExams"]),

            mPhysicals: function() {
                let eArray = [];

                _.forEach(this.physicalExams, function(exam) {
                    let e = {};

                    e.reference = exam.reference;
                    e.description = exam.description.length > 20 ? exam.description.substr(0, 20) + '...' : exam.description;
                    e.date = moment(exam.created_at).format('DD-MM-YYYY HH:mm');
                    e.id = exam.id;

                    eArray.push(e);
                });

                return eArray;
            },

            rows: function() {
                return this.mPhysicals.length;
            }
        },

        data() {
            return {
                perPage: 10,
                currentPage: 1,
                sortBy: 'date',
                sortDesc: true,
                fields: [
                    {
                        key: 'reference',
                        label: this.$i18n.tc('message.references', 1),
                    },
                    {
                        key: 'description',
                        label: this.$i18n.t('message.description'),
                    },
                    {
                        key: 'date',
                        label: this.$i18n.t('message.createdAt'),
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: this.$i18n.tc('message.operations', 1)
                    }
                ],
                offset: 0,
                limit: -1,
            }
        },

        methods: {
            getPhysicalExams() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getPhysicalExams', { args : args });
            },

            formattedDisplay (result) {
                return result.reference;
            },

            itemSelected(item) {
                this.$router.push({ name: 'consultation-physical-exam', params: { physical: item.selectedObject.slug } });
            },

            rowSelected(items) {
                this.$router.push({ name: 'consultation-physical-exam', params: { physical: items[0].slug } });
            },

            deletePhysicalExam(physical) {
                let self = this;

                let args = {
                    physical: physical
                };

                let successMessage = this.$i18n.t('message.physicalExamDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteConsultationPhysicalExam', { args, index: physical, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + physical);
                    });
            }
        },

        mounted() {
            // Fetch physical exam list
            this.getPhysicalExams();
        }
    }
</script>

<style scoped>

</style>